import { api } from "../../../api";

const root = process.env.REACT_APP_BACKEND_FINANCE_SERVICE_URL;
// const rooted = process.env.REACT_APP_BACKEND_HR_URL;

/**ALL API CALL FUNCTIONS EXPORTED AS AN OBJECT OF METHODS */

const AccountingLedgerSetup = () => {
  const route = api(root);

  return {
    CreateCOA: function (data) {
      return route.post(`/AccountLedgerSetup`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    CreateSubGroup: function (data) {
      return route.post(`/AccountLedgerSetup/sub`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    CreateAcct: function (data) {
      return route.post(`/AccountLedger`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    GetAllTransAcct: function (data) {
      // Filter out null or undefined values from the data object
      const params = Object.entries(data)
        .filter(([key, value]) => value !== null && value !== undefined) // Remove null/undefined
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`) // Map to query string
        .join('&'); // Join with '&'
    
      return route.get(`accountledger/financetransaction?${params}`);

    },

    GetAllCredit: function (data) {
      // Filter out null or undefined values from the data object
      const params = Object.entries(data)
        .filter(([key, value]) => value !== null && value !== undefined) // Remove null/undefined
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`) // Map to query string
        .join('&'); // Join with '&'
    
      return route.get(`CreditFacility/all?${params}`);
    },

    GetCredit: function (id) {
      // Filter out null or undefined values from the data object
      
      return route.get(`CreditFacility/${id}`);
    },
    

    GetAllAcct: function (data) {
      const { pageSize, pageNumber } = data;
      return route.get(
        `/AccountLedgerSetup/accountLedger?PageSize=${pageSize}&PageNumber=${pageNumber}`
      );
    },

    PostReverse: function (data) {
      return route.post(`/accountledger/reverseft`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    ApproveReverse: function (data) {
      return route.post(`/accountledger/approvedeclineft`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    DeclineReverse: function (data) {
      return route.post(`/accountledger/approvedeclineft`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    UpdateGroup: function (data) {
      return route.post(`/AccountLedgerSetup/updategroup`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    UpdateSubgroup: function (data) {
      return route.post(`/AccountLedgerSetup/updatesub`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },
  };
};

export const AccountingSetup = {
  AccountingLedgerSetup: AccountingLedgerSetup,
};
